// Translations for property content
const propertyTranslations = {
  'apartment-2': {
    name: {
      fr: 'Penthouse Roof Top Eze',
      en: 'Roof Top Eze Penthouse',
      es: 'Ático Roof Top Eze',
      de: 'Roof Top Eze Penthouse',
      it: 'Attico Roof Top Eze',
      nl: 'Roof Top Eze Penthouse',
      ru: 'Пентхаус Roof Top Eze',
      ar: 'بنتهاوس روف توب إيز',
      zh: '埃兹屋顶顶层公寓',
      ja: 'ルーフトップ・エズ・ペントハウス',
      ko: '루프탑 에즈 펜트하우스',
      hi: 'रूफ टॉप एज़ पेंटहाउस'
    },
    description: {
      fr: 'Magnifique penthouse avec vue panoramique sur la Méditerranée. Terrasse privée sur le toit avec vue imprenable sur le village médiéval d\'Eze et la mer.',
      en: 'Magnificent penthouse with panoramic views of the Mediterranean. Private rooftop terrace with stunning views of the medieval village of Eze and the sea.',
      es: 'Magnífico ático con vistas panorámicas al Mediterráneo. Terraza privada en la azotea con impresionantes vistas del pueblo medieval de Eze y el mar.',
      de: 'Herrliches Penthouse mit Panoramablick auf das Mittelmeer. Private Dachterrasse mit atemberaubendem Blick auf das mittelalterliche Dorf Eze und das Meer.',
      it: 'Magnifico attico con vista panoramica sul Mediterraneo. Terrazza privata sul tetto con vista mozzafiato sul borgo medievale di Eze e sul mare.',
      nl: 'Prachtig penthouse met panoramisch uitzicht op de Middellandse Zee. Privé dakterras met adembenemend uitzicht op het middeleeuwse dorp Eze en de zee.',
      ru: 'Великолепный пентхаус с панорамным видом на Средиземное море. Частная терраса на крыше с потрясающим видом на средневековую деревню Эз и море.',
      ar: 'بنتهاوس رائع مع إطلالة بانورامية على البحر الأبيض المتوسط. تراس خاص على السطح مع إطلالات خلابة على قرية إيز القروسطية والبحر.',
      zh: '壮丽的顶层公寓，享有地中海全景。私人屋顶露台，可欣赏埃兹中世纪村庄和大海的壮丽景色。',
      ja: '地中海のパノラマビューを望む壮大なペントハウス。エズの中世の村と海の素晴らしい景色を望むプライベートルーフトップテラス。',
      ko: '지중해의 탁 트인 전망을 자랑하는 멋진 펜트하우스. 에즈 중세 마을과 바다의 멋진 전망을 감상할 수 있는 프라이빗 루프탑 테라스.',
      hi: 'भूमध्य सागर के मनोरम दृश्यों वाला शानदार पेंटहाउस। एज़ के मध्ययुगीन गांव और समुद्र के शानदार दृश्यों वाली निजी छत की छत।'
    },
    practicalInfo: {
      fr: 'Animaux autorisés. Parking dans le jardin, 1 à 2 places selon saison.',
      en: 'Pets allowed. Garden parking, 1 to 2 spaces depending on season.',
      es: 'Se admiten mascotas. Estacionamiento en el jardín, 1 a 2 plazas según temporada.',
      de: 'Haustiere erlaubt. Gartenparkplatz, 1 bis 2 Stellplätze je nach Saison.',
      it: 'Animali ammessi. Parcheggio in giardino, 1-2 posti a seconda della stagione.',
      nl: 'Huisdieren toegestaan. Tuinparkeren, 1 tot 2 plaatsen afhankelijk van het seizoen.',
      ru: 'Домашние животные разрешены. Парковка в саду, 1-2 места в зависимости от сезона.',
      ar: 'الحيوانات الأليفة مسموح بها. موقف سيارات في الحديقة، 1 إلى 2 أماكن حسب الموسم.',
      zh: '允许携带宠物。花园停车场，根据季节提供1至2个车位。',
      ja: 'ペット可。庭駐車場、シーズンにより1〜2台。',
      ko: '반려동물 허용. 정원 주차장, 계절에 따라 1~2대.',
      hi: 'पालतू जानवरों की अनुमति है। बगीचे में पार्किंग, मौसम के अनुसार 1 से 2 स्थान।'
    }
  },
  'villa-1': {
    name: {
      fr: 'Villa au Cœur du Parc Naturel d\'Eze',
      en: 'Villa in Middle of Natural Park Eze',
      es: 'Villa en el Corazón del Parque Natural de Eze',
      de: 'Villa im Herzen des Naturparks Eze',
      it: 'Villa nel Cuore del Parco Naturale di Eze',
      nl: 'Villa in het Hart van Natuurpark Eze',
      ru: 'Вилла в Сердце Природного Парка Эз',
      ar: 'فيلا في قلب حديقة إيز الطبيعية',
      zh: '埃兹自然公园中心别墅',
      ja: 'エズ自然公園の中心にあるヴィラ',
      ko: '에즈 자연 공원 중심의 빌라',
      hi: 'एज़ प्राकृतिक पार्क के बीच में विला'
    },
    description: {
      fr: 'Villa spacieuse nichée au cœur du parc naturel d\'Eze. Cadre idyllique entouré de nature méditerranéenne, à quelques minutes de la plage et du village médiéval.',
      en: 'Spacious villa nestled in the heart of Eze Natural Park. Idyllic setting surrounded by Mediterranean nature, just minutes from the beach and medieval village.',
      es: 'Villa espaciosa ubicada en el corazón del parque natural de Eze. Entorno idílico rodeado de naturaleza mediterránea, a minutos de la playa y del pueblo medieval.',
      de: 'Geräumige Villa im Herzen des Naturparks Eze. Idyllische Umgebung umgeben von mediterraner Natur, nur wenige Minuten vom Strand und dem mittelalterlichen Dorf entfernt.',
      it: 'Villa spaziosa nel cuore del parco naturale di Eze. Ambiente idilliaco circondato dalla natura mediterranea, a pochi minuti dalla spiaggia e dal borgo medievale.',
      nl: 'Ruime villa gelegen in het hart van het natuurpark Eze. Idyllische omgeving omgeven door mediterrane natuur, op enkele minuten van het strand en het middeleeuwse dorp.',
      ru: 'Просторная вилла в самом сердце природного парка Эз. Идиллическая обстановка в окружении средиземноморской природы, всего в нескольких минутах от пляжа и средневековой деревни.',
      ar: 'فيلا واسعة تقع في قلب حديقة إيز الطبيعية. بيئة خلابة محاطة بالطبيعة المتوسطية، على بعد دقائق من الشاطئ والقرية القروسطية.',
      zh: '宽敞的别墅坐落在埃兹自然公园的中心。周围环绕着地中海自然风光，距离海滩和中世纪村庄仅几分钟路程。',
      ja: 'エズ自然公園の中心部に位置する広々としたヴィラ。地中海の自然に囲まれた牧歌的な環境で、ビーチや中世の村から数分です。',
      ko: '에즈 자연 공원의 중심부에 자리 잡은 넓은 빌라. 지중해 자연으로 둘러싸인 목가적인 환경으로, 해변과 중세 마을에서 단 몇 분 거리입니다.',
      hi: 'एज़ प्राकृतिक पार्क के केंद्र में स्थित विशाल विला। भूमध्यसागरीय प्रकृति से घिरा सुरम्य परिवेश, समुद्र तट और मध्ययुगीन गांव से कुछ ही मिनट की दूरी पर।'
    },
    practicalInfo: {
      fr: 'Animaux autorisés. Parking souterrain au village gratuit, nous vous fournirons une carte de stationnement.',
      en: 'Pets allowed. Free underground parking in the village, we will provide you with a parking card.',
      es: 'Se admiten mascotas. Estacionamiento subterráneo gratuito en el pueblo, le proporcionaremos una tarjeta de estacionamiento.',
      de: 'Haustiere erlaubt. Kostenlose Tiefgarage im Dorf, wir stellen Ihnen eine Parkkarte zur Verfügung.',
      it: 'Animali ammessi. Parcheggio sotterraneo gratuito nel villaggio, vi forniremo una tessera parcheggio.',
      nl: 'Huisdieren toegestaan. Gratis ondergrondse parking in het dorp, wij zorgen voor een parkeerkaart.',
      ru: 'Домашние животные разрешены. Бесплатная подземная парковка в деревне, мы предоставим вам парковочную карту.',
      ar: 'الحيوانات الأليفة مسموح بها. موقف سيارات تحت الأرض مجاني في القرية، سنزودك ببطاقة وقوف السيارات.',
      zh: '允许携带宠物。村内免费地下停车场，我们将为您提供停车卡。',
      ja: 'ペット可。村の無料地下駐車場、駐車カードを提供します。',
      ko: '반려동물 허용. 마을 무료 지하 주차장, 주차 카드를 제공해 드립니다.',
      hi: 'पालतू जानवरों की अनुमति है। गांव में मुफ्त भूमिगत पार्किंग, हम आपको पार्किंग कार्ड प्रदान करेंगे।'
    }
  },
  'apartment-1': {
    name: {
      fr: 'Front de Mer Eze avec Piscine',
      en: 'Front Beach Eze with Swimming Pool',
      es: 'Frente al Mar Eze con Piscina',
      de: 'Strandfront Eze mit Pool',
      it: 'Fronte Mare Eze con Piscina',
      nl: 'Zeefront Eze met Zwembad',
      ru: 'На Берегу Моря Эз с Бассейном',
      ar: 'واجهة الشاطئ إيز مع مسبح',
      zh: '埃兹海滨泳池公寓',
      ja: 'プール付きエズ・ビーチフロント',
      ko: '수영장이 있는 에즈 해변 전면',
      hi: 'स्विमिंग पूल के साथ फ्रंट बीच एज़'
    },
    description: {
      fr: 'Appartement de standing en front de mer avec accès direct à la plage. Piscine commune avec vue sur la baie, parfait pour des vacances ensoleillées sur la Côte d\'Azur.',
      en: 'Upscale beachfront apartment with direct beach access. Shared pool with bay views, perfect for sunny holidays on the French Riviera.',
      es: 'Apartamento de lujo frente al mar con acceso directo a la playa. Piscina compartida con vistas a la bahía, perfecto para vacaciones soleadas en la Costa Azul.',
      de: 'Gehobenes Apartment direkt am Strand mit direktem Strandzugang. Gemeinschaftspool mit Blick auf die Bucht, perfekt für sonnige Ferien an der Côte d\'Azur.',
      it: 'Appartamento di lusso sul mare con accesso diretto alla spiaggia. Piscina condivisa con vista sulla baia, perfetto per vacanze soleggiate in Costa Azzurra.',
      nl: 'Luxe appartement aan het strand met directe toegang tot het strand. Gedeeld zwembad met uitzicht op de baai, perfect voor zonnige vakanties aan de Côte d\'Azur.',
      ru: 'Элитная квартира на берегу моря с прямым выходом на пляж. Общий бассейн с видом на залив, идеально подходит для солнечного отдыха на Лазурном берегу.',
      ar: 'شقة فاخرة على الواجهة البحرية مع وصول مباشر للشاطئ. مسبح مشترك مع إطلالات على الخليج، مثالية للعطلات المشمسة على الريفييرا الفرنسية.',
      zh: '高档海滨公寓，可直接通往海滩。共用泳池享有海湾美景，是在法国蔚蓝海岸度过阳光假期的完美选择。',
      ja: 'ビーチへ直接アクセスできる高級ビーチフロントアパートメント。湾の景色を望む共用プール、フレンチリビエラでの日当たりの良い休暇に最適です。',
      ko: '해변에 직접 접근할 수 있는 고급 해변 아파트. 만의 전망을 갖춘 공용 수영장, 프렌치 리비에라에서 햇살 가득한 휴가를 보내기에 완벽합니다.',
      hi: 'समुद्र तट तक सीधी पहुंच वाला अपस्केल बीचफ्रंट अपार्टमेंट। खाड़ी के दृश्यों वाला साझा पूल, फ्रेंच रिवेरा पर धूप भरी छुट्टियों के लिए बिल्कुल सही।'
    },
    practicalInfo: {
      fr: 'Animaux autorisés. Alarme de sécurité dans l\'appartement. Piscine sécurisée pour les enfants (mais n\'empêche pas la vigilance des adultes). Parking dans le jardin, 1 à 2 places selon saison.',
      en: 'Pets allowed. Security alarm in the apartment. Pool secured for children (but does not replace adult supervision). Garden parking, 1 to 2 spaces depending on season.',
      es: 'Se admiten mascotas. Alarma de seguridad en el apartamento. Piscina asegurada para niños (pero no reemplaza la supervisión de adultos). Estacionamiento en el jardín, 1 a 2 plazas según temporada.',
      de: 'Haustiere erlaubt. Sicherheitsalarm in der Wohnung. Gesicherter Pool für Kinder (ersetzt jedoch nicht die Aufsicht durch Erwachsene). Gartenparkplatz, 1 bis 2 Stellplätze je nach Saison.',
      it: 'Animali ammessi. Allarme di sicurezza nell\'appartamento. Piscina messa in sicurezza per bambini (ma non sostituisce la sorveglianza degli adulti). Parcheggio in giardino, 1-2 posti a seconda della stagione.',
      nl: 'Huisdieren toegestaan. Beveiligingsalarm in het appartement. Beveiligd zwembad voor kinderen (maar vervangt geen toezicht door volwassenen). Tuinparkeren, 1 tot 2 plaatsen afhankelijk van het seizoen.',
      ru: 'Домашние животные разрешены. Охранная сигнализация в квартире. Бассейн безопасен для детей (но не заменяет присмотр взрослых). Парковка в саду, 1-2 места в зависимости от сезона.',
      ar: 'الحيوانات الأليفة مسموح بها. إنذار أمني في الشقة. مسبح مؤمن للأطفال (ولكن لا يغني عن مراقبة الكبار). موقف سيارات في الحديقة، 1 إلى 2 أماكن حسب الموسم.',
      zh: '允许携带宠物。公寓内配有安全警报。儿童安全泳池（但不能取代成人监督）。花园停车场，根据季节提供1至2个车位。',
      ja: 'ペット可。アパートにセキュリティアラーム。子供向けに安全対策されたプール（ただし大人の監督に代わるものではありません）。庭駐車場、シーズンにより1〜2台。',
      ko: '반려동물 허용. 아파트 내 보안 경보기. 어린이를 위한 안전한 수영장 (그러나 성인 감독을 대체하지는 않습니다). 정원 주차장, 계절에 따라 1~2대.',
      hi: 'पालतू जानवरों की अनुमति है। अपार्टमेंट में सुरक्षा अलार्म। बच्चों के लिए सुरक्षित पूल (लेकिन वयस्क निगरानी की जगह नहीं लेता)। बगीचे में पार्किंग, मौसम के अनुसार 1 से 2 स्थान।'
    }
  }
};

// Amenity translations
const amenityTranslations = {
  'WiFi': {
    fr: 'WiFi', en: 'WiFi', es: 'WiFi', de: 'WLAN', it: 'WiFi', nl: 'WiFi', ru: 'WiFi', ar: 'واي فاي', zh: 'WiFi', ja: 'WiFi', ko: 'WiFi', hi: 'वाईफाई'
  },
  'Parking': {
    fr: 'Parking', en: 'Parking', es: 'Aparcamiento', de: 'Parkplatz', it: 'Parcheggio', nl: 'Parkeren', ru: 'Парковка', ar: 'موقف سيارات', zh: '停车场', ja: '駐車場', ko: '주차장', hi: 'पार्किंग'
  },
  'Pool': {
    fr: 'Piscine', en: 'Pool', es: 'Piscina', de: 'Pool', it: 'Piscina', nl: 'Zwembad', ru: 'Бассейн', ar: 'مسبح', zh: '游泳池', ja: 'プール', ko: '수영장', hi: 'पूल'
  },
  'Piscine': {
    fr: 'Piscine', en: 'Pool', es: 'Piscina', de: 'Pool', it: 'Piscina', nl: 'Zwembad', ru: 'Бассейн', ar: 'مسبح', zh: '游泳池', ja: 'プール', ko: '수영장', hi: 'पूल'
  },
  'Air Conditioning': {
    fr: 'Climatisation', en: 'Air Conditioning', es: 'Aire Acondicionado', de: 'Klimaanlage', it: 'Aria Condizionata', nl: 'Airconditioning', ru: 'Кондиционер', ar: 'تكييف الهواء', zh: '空调', ja: 'エアコン', ko: '에어컨', hi: 'एयर कंडीशनिंग'
  },
  'Climatisation': {
    fr: 'Climatisation', en: 'Air Conditioning', es: 'Aire Acondicionado', de: 'Klimaanlage', it: 'Aria Condizionata', nl: 'Airconditioning', ru: 'Кондиционер', ar: 'تكييف الهواء', zh: '空调', ja: 'エアコン', ko: '에어컨', hi: 'एयर कंडीशनिंग'
  },
  'Kitchen': {
    fr: 'Cuisine', en: 'Kitchen', es: 'Cocina', de: 'Küche', it: 'Cucina', nl: 'Keuken', ru: 'Кухня', ar: 'مطبخ', zh: '厨房', ja: 'キッチン', ko: '주방', hi: 'रसोई'
  },
  'Cuisine': {
    fr: 'Cuisine', en: 'Kitchen', es: 'Cocina', de: 'Küche', it: 'Cucina', nl: 'Keuken', ru: 'Кухня', ar: 'مطبخ', zh: '厨房', ja: 'キッチン', ko: '주방', hi: 'रसोई'
  },
  'Terrace': {
    fr: 'Terrasse', en: 'Terrace', es: 'Terraza', de: 'Terrasse', it: 'Terrazza', nl: 'Terras', ru: 'Терраса', ar: 'تراس', zh: '露台', ja: 'テラス', ko: '테라스', hi: 'छत'
  },
  'Terrasse': {
    fr: 'Terrasse', en: 'Terrace', es: 'Terraza', de: 'Terrasse', it: 'Terrazza', nl: 'Terras', ru: 'Терраса', ar: 'تراس', zh: '露台', ja: 'テラス', ko: '테라스', hi: 'छत'
  },
  'Sea View': {
    fr: 'Vue Mer', en: 'Sea View', es: 'Vista al Mar', de: 'Meerblick', it: 'Vista Mare', nl: 'Zeezicht', ru: 'Вид на Море', ar: 'إطلالة على البحر', zh: '海景', ja: '海の眺め', ko: '바다 전망', hi: 'समुद्र का दृश्य'
  },
  'Vue Mer': {
    fr: 'Vue Mer', en: 'Sea View', es: 'Vista al Mar', de: 'Meerblick', it: 'Vista Mare', nl: 'Zeezicht', ru: 'Вид на Море', ar: 'إطلالة على البحر', zh: '海景', ja: '海の眺め', ko: '바다 전망', hi: 'समुद्र का दृश्य'
  },
  'Garden': {
    fr: 'Jardin', en: 'Garden', es: 'Jardín', de: 'Garten', it: 'Giardino', nl: 'Tuin', ru: 'Сад', ar: 'حديقة', zh: '花园', ja: '庭園', ko: '정원', hi: 'बगीचा'
  },
  'Jardin': {
    fr: 'Jardin', en: 'Garden', es: 'Jardín', de: 'Garten', it: 'Giardino', nl: 'Tuin', ru: 'Сад', ar: 'حديقة', zh: '花园', ja: '庭園', ko: '정원', hi: 'बगीचा'
  },
  'Washing Machine': {
    fr: 'Lave-linge', en: 'Washing Machine', es: 'Lavadora', de: 'Waschmaschine', it: 'Lavatrice', nl: 'Wasmachine', ru: 'Стиральная машина', ar: 'غسالة', zh: '洗衣机', ja: '洗濯機', ko: '세탁기', hi: 'वॉशिंग मशीन'
  },
  'Lave-linge': {
    fr: 'Lave-linge', en: 'Washing Machine', es: 'Lavadora', de: 'Waschmaschine', it: 'Lavatrice', nl: 'Wasmachine', ru: 'Стиральная машина', ar: 'غسالة', zh: '洗衣机', ja: '洗濯機', ko: '세탁기', hi: 'वॉशिंग मशीन'
  },
  'Dishwasher': {
    fr: 'Lave-vaisselle', en: 'Dishwasher', es: 'Lavavajillas', de: 'Geschirrspüler', it: 'Lavastoviglie', nl: 'Vaatwasser', ru: 'Посудомоечная машина', ar: 'غسالة صحون', zh: '洗碗机', ja: '食洗機', ko: '식기세척기', hi: 'डिशवॉशर'
  },
  'Lave-vaisselle': {
    fr: 'Lave-vaisselle', en: 'Dishwasher', es: 'Lavavajillas', de: 'Geschirrspüler', it: 'Lavastoviglie', nl: 'Vaatwasser', ru: 'Посудомоечная машина', ar: 'غسالة صحون', zh: '洗碗机', ja: '食洗機', ko: '식기세척기', hi: 'डिशवॉशर'
  },
  'BBQ': {
    fr: 'Barbecue', en: 'BBQ', es: 'Barbacoa', de: 'Grill', it: 'Barbecue', nl: 'BBQ', ru: 'Барбекю', ar: 'شواء', zh: '烧烤', ja: 'BBQ', ko: '바베큐', hi: 'बारबेक्यू'
  },
  'Barbecue': {
    fr: 'Barbecue', en: 'BBQ', es: 'Barbacoa', de: 'Grill', it: 'Barbecue', nl: 'BBQ', ru: 'Барбекю', ar: 'شواء', zh: '烧烤', ja: 'BBQ', ko: '바베큐', hi: 'बारबेक्यू'
  },
  'Pets Allowed': {
    fr: 'Animaux acceptés', en: 'Pets Allowed', es: 'Mascotas permitidas', de: 'Haustiere erlaubt', it: 'Animali ammessi', nl: 'Huisdieren toegestaan', ru: 'Животные разрешены', ar: 'الحيوانات الأليفة مسموح بها', zh: '允许携带宠物', ja: 'ペット可', ko: '반려동물 허용', hi: 'पालतू जानवरों की अनुमति'
  },
  'Animaux acceptés': {
    fr: 'Animaux acceptés', en: 'Pets Allowed', es: 'Mascotas permitidas', de: 'Haustiere erlaubt', it: 'Animali ammessi', nl: 'Huisdieren toegestaan', ru: 'Животные разрешены', ar: 'الحيوانات الأليفة مسموح بها', zh: '允许携带宠物', ja: 'ペット可', ko: '반려동물 허용', hi: 'पालतू जानवरों की अनुमति'
  },
  'Security Alarm': {
    fr: 'Alarme de sécurité', en: 'Security Alarm', es: 'Alarma de seguridad', de: 'Sicherheitsalarm', it: 'Allarme di sicurezza', nl: 'Beveiligingsalarm', ru: 'Охранная сигнализация', ar: 'إنذار أمني', zh: '安全警报', ja: 'セキュリティアラーム', ko: '보안 알람', hi: 'सुरक्षा अलार्म'
  },
  'Alarme de sécurité': {
    fr: 'Alarme de sécurité', en: 'Security Alarm', es: 'Alarma de seguridad', de: 'Sicherheitsalarm', it: 'Allarme di sicurezza', nl: 'Beveiligingsalarm', ru: 'Охранная сигнализация', ar: 'إنذار أمني', zh: '安全警报', ja: 'セキュリティアラーム', ko: '보안 알람', hi: 'सुरक्षा अलार्म'
  },
  'Garden Parking': {
    fr: 'Parking dans le jardin', en: 'Garden Parking', es: 'Aparcamiento en jardín', de: 'Gartenparkplatz', it: 'Parcheggio in giardino', nl: 'Tuinparkeren', ru: 'Парковка в саду', ar: 'موقف سيارات في الحديقة', zh: '花园停车场', ja: '庭駐車場', ko: '정원 주차장', hi: 'गार्डन पार्किंग'
  },
  'Parking dans le jardin': {
    fr: 'Parking dans le jardin', en: 'Garden Parking', es: 'Aparcamiento en jardín', de: 'Gartenparkplatz', it: 'Parcheggio in giardino', nl: 'Tuinparkeren', ru: 'Парковка в саду', ar: 'موقف سيارات في الحديقة', zh: '花园停车场', ja: '庭駐車場', ko: '정원 주차장', hi: 'गार्डन पार्किंग'
  },
  'Jacuzzi': {
    fr: 'Jacuzzi', en: 'Jacuzzi', es: 'Jacuzzi', de: 'Whirlpool', it: 'Jacuzzi', nl: 'Jacuzzi', ru: 'Джакузи', ar: 'جاكوزي', zh: '按摩浴缸', ja: 'ジャグジー', ko: '자쿠지', hi: 'जकूज़ी'
  },
  'Panoramic View': {
    fr: 'Vue Panoramique', en: 'Panoramic View', es: 'Vista Panorámica', de: 'Panoramablick', it: 'Vista Panoramica', nl: 'Panoramisch Uitzicht', ru: 'Панорамный Вид', ar: 'إطلالة بانورامية', zh: '全景', ja: 'パノラマビュー', ko: '파노라마 뷰', hi: 'पैनोरमिक व्यू'
  },
  'Vue Panoramique': {
    fr: 'Vue Panoramique', en: 'Panoramic View', es: 'Vista Panorámica', de: 'Panoramablick', it: 'Vista Panoramica', nl: 'Panoramisch Uitzicht', ru: 'Панорамный Вид', ar: 'إطلالة بانورامية', zh: '全景', ja: 'パノラマビュー', ko: '파노라마 뷰', hi: 'पैनोरमिक व्यू'
  },
  'TV': {
    fr: 'TV', en: 'TV', es: 'TV', de: 'Fernseher', it: 'TV', nl: 'TV', ru: 'ТВ', ar: 'تلفاز', zh: '电视', ja: 'テレビ', ko: 'TV', hi: 'टीवी'
  },
  'Private Pool': {
    fr: 'Piscine Privée', en: 'Private Pool', es: 'Piscina Privada', de: 'Privater Pool', it: 'Piscina Privata', nl: 'Privé Zwembad', ru: 'Частный Бассейн', ar: 'مسبح خاص', zh: '私人泳池', ja: 'プライベートプール', ko: '전용 수영장', hi: 'निजी पूल'
  },
  'Piscine Privée': {
    fr: 'Piscine Privée', en: 'Private Pool', es: 'Piscina Privada', de: 'Privater Pool', it: 'Piscina Privata', nl: 'Privé Zwembad', ru: 'Частный Бассейн', ar: 'مسبح خاص', zh: '私人泳池', ja: 'プライベートプール', ko: '전용 수영장', hi: 'निजी पूल'
  },
  'Equipped Kitchen': {
    fr: 'Cuisine Équipée', en: 'Equipped Kitchen', es: 'Cocina Equipada', de: 'Ausgestattete Küche', it: 'Cucina Attrezzata', nl: 'Uitgeruste Keuken', ru: 'Оборудованная Кухня', ar: 'مطبخ مجهز', zh: '设备齐全的厨房', ja: '設備付きキッチン', ko: '설비 완비 주방', hi: 'सुसज्जित रसोई'
  },
  'Cuisine Équipée': {
    fr: 'Cuisine Équipée', en: 'Equipped Kitchen', es: 'Cocina Equipada', de: 'Ausgestattete Küche', it: 'Cucina Attrezzata', nl: 'Uitgeruste Keuken', ru: 'Оборудованная Кухня', ar: 'مطبخ مجهز', zh: '设备齐全的厨房', ja: '設備付きキッチン', ko: '설비 완비 주방', hi: 'सुसज्जित रसोई'
  },
  'Wi-Fi': {
    fr: 'Wi-Fi', en: 'Wi-Fi', es: 'Wi-Fi', de: 'WLAN', it: 'Wi-Fi', nl: 'Wi-Fi', ru: 'Wi-Fi', ar: 'واي فاي', zh: 'WiFi', ja: 'Wi-Fi', ko: 'Wi-Fi', hi: 'वाई-फाई'
  }
};

// Helper functions
export function getPropertyName(propertyId, language) {
  const translations = propertyTranslations[propertyId];
  if (!translations) return null;
  return translations.name[language] || translations.name['en'];
}

export function getPropertyDescription(propertyId, language) {
  const translations = propertyTranslations[propertyId];
  if (!translations) return null;
  return translations.description[language] || translations.description['en'];
}

export function getAmenityTranslation(amenity, language) {
  const translations = amenityTranslations[amenity];
  if (!translations) return amenity;
  return translations[language] || translations['en'] || amenity;
}

export function getPropertyPracticalInfo(propertyId, language) {
  const translations = propertyTranslations[propertyId];
  if (!translations || !translations.practicalInfo) return null;
  return translations.practicalInfo[language] || translations.practicalInfo['en'];
}

export { propertyTranslations, amenityTranslations };
